import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { InvoiceDiscrepancies, Invoices } from '../../../data/interfaces';
import { ProfileCountryService } from '../../../shared/services/profile-country.service';

@Injectable({
  providedIn: 'root'
})
export class InvoiceService {

  private baseUrl = environment.apiUrl;

  constructor(private http: HttpClient, private profileCountryService: ProfileCountryService) { }

  private getCountryParams(): any {
    const profileCountry = this.profileCountryService.getProfileCountryForApi();
    return profileCountry ? { profileCountry } : {};
  }

  getInvoices(filter: any) {
    return this.http.get<Invoices[]>(`${this.baseUrl}/invoice/list`, { params: filter });
  }

  downloadInvoice(invoiceNo: string) {
    return this.http.get(`${this.baseUrl}/invoice/download/${invoiceNo}`);
  }

  getDiscrepancies(filter: any) {
    const params = { ...filter, ...this.getCountryParams() };
    return this.http.get<InvoiceDiscrepancies[]>(`${this.baseUrl}/invoice/discrepancies`, { params });
  }

  addDiscrepancy(shipmentId: string, owner?: string) {
    const payload: any = { shipmentId };
    if (owner) payload.owner = owner;
    return this.http.post<InvoiceDiscrepancies>(`${this.baseUrl}/invoice/addDiscrepancy`, payload);
  }

  updateDiscrepancy(id: string, discrepancy: InvoiceDiscrepancies) {
    return this.http.put<InvoiceDiscrepancies>(`${this.baseUrl}/invoice/discrepancy/${id}`, discrepancy);
  }

  deleteDiscrepancy(id: string) {
    return this.http.delete<InvoiceDiscrepancies>(`${this.baseUrl}/invoice/discrepancy/${id}`);
  }

  bulkDeleteDiscrepancies(ids: string[]) {
    return this.http.post<{ message: string; count: number }>(`${this.baseUrl}/invoice/discrepancies/bulk-delete`, { ids });
  }

  bulkUpdateDiscrepancyStatus(ids: string[], status: string) {
    return this.http.put<{ message: string; count: number; status: string }>(`${this.baseUrl}/invoice/discrepancies/bulk-status`, { ids, status });
  }

}
